import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const TransportAdd: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'load';
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [form, setForm] = useState({
    type: type,
    vehicle_type: '',
    capacity: '',
    origin: '',
    destination: '',
    description: '',
    price: '',
    contact_phone: '',
    date_needed: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm({...form, [e.target.name]: e.target.value});
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      // در اینجا API ثبت بار و ماشین را اضافه کنید
      setSuccess('درخواست با موفقیت ثبت شد.');
      setTimeout(() => navigate('/transport'), 2000);
    } catch {
      setError('خطا در ثبت درخواست');
    }
    setLoading(false);
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>{type === 'load' ? 'ثبت بار' : 'ثبت ماشین'}</h1>
        </div>
      </div>
      <section style={{ padding: '20px 0' }}>
        <div className="container">
          <div style={{ maxWidth: '600px', margin: '0 auto', background: '#fff', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
            {error && <div className="alert alert-error">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>مبدا</label>
                <input type="text" name="origin" value={form.origin} onChange={handleChange} required style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>مقصد</label>
                <input type="text" name="destination" value={form.destination} onChange={handleChange} required style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
              </div>
              {type === 'load' ? (
                <>
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>نوع بار</label>
                    <input type="text" name="description" value={form.description} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>وزن</label>
                    <input type="text" name="capacity" value={form.capacity} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
                  </div>
                </>
              ) : (
                <>
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>نوع ماشین</label>
                    <select name="vehicle_type" value={form.vehicle_type} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}>
                      <option value="نیسان">نیسان</option>
                      <option value="خاور">خاور</option>
                      <option value="کامیونت">کامیونت</option>
                      <option value="تریلی">تریلی</option>
                    </select>
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>ظرفیت</label>
                    <input type="text" name="capacity" value={form.capacity} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
                  </div>
                </>
              )}
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>قیمت (تومان - اختیاری)</label>
                <input type="number" name="price" value={form.price} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>شماره تماس</label>
                <input type="tel" name="contact_phone" value={form.contact_phone} onChange={handleChange} required style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
              </div>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', fontWeight: '600', marginBottom: '5px' }}>تاریخ مورد نیاز (اختیاری)</label>
                <input type="date" name="date_needed" value={form.date_needed} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }} />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
                {loading ? 'در حال ثبت...' : 'ثبت درخواست'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default TransportAdd;